import type { TokenTransparency } from '@blockworks/platform/api/strapi';

export const calculateTotalTransparencyScore = (tt: TokenTransparency): number => {
    const projectScore = tt.projectAndTeamRating ?? 0;
    const supplyScore = tt.tokenSupplyAndAllocationRating ?? 0;
    const transactionScore = tt.transactionsAndMarketStructureRating ?? 0;
    const financialScore = tt.financialDisclosureRating ?? 0;

    return projectScore + supplyScore + transactionScore + financialScore;
};
